import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class CustomValidators {
  static requiredWhenSelected(requiredControl: string, checkedControl: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const checked = control.get(checkedControl);
      const required = control.get(requiredControl);

      return checked.value && !required.value ? { requiredWhenSelected: true } : null
    }
  }
}
